import React from 'react';
import Divider from '@/components/Divider';
import { FaPlus } from 'react-icons/fa';
import { Box, Dropdown } from '@legion-ui/core';
import Button from '../Button';
import { ModalType } from '@/store/modal';

interface SectionHeaderProps {
  title: string;
  className?: string;
  showAddRole?: boolean;
  isDisabled?: boolean;
  toggleModal?: (type: ModalType) => void;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  className,
  showAddRole = false,
  toggleModal,
  isDisabled,
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      <div className="flex items-center justify-between">
        <h1 className="sm:text-lg text-sm font-bold text-[#002E84]">{title}</h1>
        {isDisabled ? (
          <Button size="sm" iconRight={<FaPlus />} disabled={isDisabled}>
            Add Role
          </Button>
        ) : (
          showAddRole && (
            <Dropdown
              onClose={function noRefCheck() {}}
              position="center"
              trigger={
                <Button size="sm" iconRight={<FaPlus />} disabled={isDisabled}>
                  Add Role
                </Button>
              }
            >
              <Box alignX="center">
                <Button
                  className="w-full"
                  variant="soft"
                  onClick={() =>
                    toggleModal && toggleModal(ModalType.AddPublisher)
                  }
                >
                  Publisher
                </Button>
                <Button
                  className="w-full"
                  variant="soft"
                  onClick={() => toggleModal && toggleModal(ModalType.AddAdmin)}
                >
                  Admin
                </Button>
              </Box>
            </Dropdown>
          )
        )}

        {/* Add Role in Header */}
      </div>
      <Divider />
    </div>
  );
};

export default SectionHeader;
